<template>
    <div class="settings-row">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'AtomBase'
}
</script>

<style>
    .settings-row {
        flex: 1;
        display: flex;
        flex-direction: row;
        color: rgb(var(--v-theme-primary));
        max-width: 1000px;
        width: 100%;
    }
</style>